import request from '../http';

// 获取标签列表
export const listTags = (params) =>
  request({ url: '/material/tags', method: 'get', params });

// 创建标签
export const createTag = (data) =>
  request({ url: '/material/tags', method: 'post', data });

// 更新标签
export const updateTag = (id, data) =>
  request({ url: `/material/tags/${id}`, method: 'put', data });

// 删除标签
export const deleteTag = (id) =>
  request({ url: `/material/tags/${id}`, method: 'delete' });
